// extracted by mini-css-extract-plugin
export default {"container_form":"styles_container_form__VqejK","double_input":"styles_double_input__wH0MF","doubleInput":"styles_doubleInput__tE-1E"};